import classnames from 'classnames';
// import PropTypes from 'prop-types';
import React from 'react';
import {WebUI, getNid} from "../../wui-core/src";
import { IconProps } from './iIcon';
import { WithConfigConsumer } from '../../wui-provider/src/context';

// const propTypes = {
//     type: PropTypes.string,
//     fontName: PropTypes.string,
//     rotate: PropTypes.number,
//     style: PropTypes.object,
//     className: PropTypes.string,
// };
/**
 *  badge 默认显示内容1
 */
const defaultProps = {
    fontName: 'tinpericon uf',
    type: '',
    className: '',
    style: {}
};

const IconComponent: React.FC<IconProps> = (props) => {
    const { clsPrefix, fontName, type, className, dir, style, ...others } = props;

    let Style = {}
    if (!!props.rotate && typeof props.rotate === 'number') {
        Style = {
            transform: `rotate(${props.rotate}deg)`,
            display: 'inline-block'
        };
    }

    const classNames = classnames(clsPrefix, fontName, type, className, `${clsPrefix}-${dir}`);
    const adapterNid = getNid(props);

    return (
        <i
            {...others}
            className={classNames}
            style={{...Style, ...style}}
            {...adapterNid}
        />
    );
};

const Icon = WithConfigConsumer()(WebUI({ name: "icon", defaultProps })(IconComponent));

// Icon.propTypes = propTypes;

export default Icon;
